import path from 'path';
import hydrate from '../../lib/hydrate';
import CheckoutWrapper from '../../lib/components/CheckoutPage/CheckoutWrapper';

hydrate({
  frontend: path.basename(__filename, '.jsx'),
  component: CheckoutWrapper,
});
